export default "__VITE_ASSET__CkkMaw4W__"